import { Card, Col, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import './DataImportExportHome.css'

const { Title, Text } = Typography;

const DataImportExportHome = () => {
    const navigate = useNavigate();

    const cards = [
        {
            key: "import",
            title: "Import",
            img: "../images/Data_Import.png",
            onClick: () => navigate('/data-import-page'),
        },
        {
            key: "export",
            title: "Export",
            img: "../images/Data_Export.png",
            onClick: () => navigate("/data-export-page"),
        },
    ];

    return (
        <div>
            <Title level={3} style=
            {{ 
                color: '#3E767A',
                marginBottom: 24,
                 fontWeight: 'bold',
             }}>
                Data Import Export
            </Title>
            <Row gutter={[20, 20]}>
                {cards.map((card) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={card.key}>
                        <Card
                            className="import-export"
                            hoverable
                            cover={<img src={card.img} alt={card.title} />}
                            onClick={card.onClick}
                            >
                            <div className="overlay">
                                <Title level={4} className="overlay-title">
                                    {card.title}
                                </Title>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default DataImportExportHome;
